import { render } from "./ListOrdered.vue?vue&type=template&id=1d28f6c7"
import script from "./ListOrdered.vue?vue&type=script&lang=js"
export * from "./ListOrdered.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__